module.exports = __webpack_public_path__ + "img/banner2.4ee02b88.png";